export default "__VITE_ASSET__5cebea9e__"